// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum RhSensorEnum {
    Opi = 'Opi',
    PowerCast = 'PowerCast',
    BinSense = 'BinSense',
}
export default RhSensorEnum;
